import { render } from "./GlobalAdventureMenu.vue?vue&type=template&id=59c2958c&scoped=true"
import script from "./GlobalAdventureMenu.vue?vue&type=script&lang=js"
export * from "./GlobalAdventureMenu.vue?vue&type=script&lang=js"

import "./GlobalAdventureMenu.vue?vue&type=style&index=0&id=59c2958c&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-59c2958c"]])

export default __exports__